export enum SalesConciergeRequestType {
    NEW_ACQUISITION = 'Neuanschaffung von Brother Produkten',
    TECHNICAL_ISSUE_OR_SUPPORT = 'Technischer Defekt oder Supportanfrage',
    DEALER_CONTRACT_OR_BILLING_ISSUES = 'Händlervertrags- oder Abrechnungsthemen',
    OTHER_ISSUES = 'Sonstiges Thema',
    NO_INFORMATION = 'Keine Angabe'
}

